module.exports = __webpack_public_path__ + "img/search.e7b66d57.svg";